import Vue from 'vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

Vue.component('ModalElement', () => import('@/components/common/ModalElement.vue'));
Vue.component('Loading', () => import('@/components/common/Loading.vue'));
Vue.component('Icon', () => import('@/components/base/svg/SVG.vue'));
Vue.component('SvgElement', () => import('@/components/base/svg/SVG.vue'));
Vue.component('ButtonComponent', () => import('@/components/common/ButtonComponent.vue'));
Vue.component('VSelect', () => import('vue-select'));
Vue.component('AvatarPlaceholder', () => import('vue-avatar')); //Avatar
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);


